
    import { mapState, mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faChartSimple as farChartSimple,
    } from '@fortawesome/pro-solid-svg-icons/faChartSimple';

    import JobViewChartModal from '@/components/JobView/JobViewChartModal';
    import JobViewPayComparisonModal from '@/components/JobView/JobViewPayComparisonModal';

    export default {
        name: 'JobViewPayInsightsButton',

        components: {
            JobViewChartModal,
            JobViewPayComparisonModal,
            FontAwesomeIcon,
        },

        data() {
            return {
                showProfileModal: false,
                showPayComparisonModal: false,
                icons: {
                    farChartSimple,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            ...mapGetters('job', {
                $_pay: 'pay',
                $_payLabel: 'payLabel',
                $_marketPay: 'marketPay',
                $_marketAveragePayShortLabel: 'marketAveragePayShortLabel',
                $_occupationLabel: 'occupationLabel',
                $_locationLabel: 'locationLabel',
                $_isPayAboveAvg: 'isPayAboveAvg',
                $_showChart: 'showChart',
                $_payData: 'payData',
                $_chartType: 'chartType',
            }),

            table() {
                return [
                    {
                        label: `${this.$_payLabel} range`,
                        figure: this.$_pay.payMinMaxShortLabelRange,
                        variant: 'secondary',
                        is_dark: true,
                    },
                    {
                        label: 'Market average',
                        figure: this.$_marketAveragePayShortLabel,
                        variant: '',
                        is_dark: false,
                    },
                ];
            },
        },

        methods: {
            openModal() {
                if (this.$_me.profile_status === 'onboarded') {
                    this.showProfileModal = true;
                } else {
                    this.showPayComparisonModal = true;
                }
            },
            closeModal() {
                this.showProfileModal = false;
                this.showPayComparisonModal = false;
            },
        },
    };
